import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  puzzleData,
  puzzlecomplated,
  puzzlecountData,
  puzzledaily,
  puzzlefinishData,
} from '../const';

@Injectable({
  providedIn: 'root',
})
export class PuzzleService {
  constructor(private http: HttpClient) {}

  puzzleGetData(data: any) {
    return this.http.post<any>(`${puzzleData}`, data);
  }
  puzzlescount(data: any) {
    return this.http.post<any>(`${puzzlecountData}`, data);
  }

  solvePuzzle(data: any) {
    return this.http.post<any>(`${puzzlefinishData}`, data);
  }

  complatepuzzle(pageNumber: any) {
    return this.http.get<any>(`${puzzlecomplated}?page=${pageNumber}`);
  }
  
  dailypuzzle() {
    return this.http.get<any>(`${puzzledaily}`);
  }
}
